import { Navigate } from 'react-router-dom'
import { Route, Routes } from 'react-router'

import { ApplicationsContainer } from '@pages/applications'
import { SignatureContainer } from '@pages/signature'
import { CommercialOffersContainer } from '@pages/commercialOffers'
import { CompaniesContainer } from '@pages/companies'
import { ListenersContainer } from '@pages/listeners'
import { ContractsContainer } from '@pages/contracts'
import { FinalExaminationContainer } from '@pages/finalExamination'
import { ArchiveFinalExaminationContainer } from '@pages/finalExaminationArchive'
import { FinalityContainer } from '@pages/finality'
import { PrintingsFinalExaminationsContainer } from '@pages/finalExaminationsPrint'
import { UsersContainer } from '@pages/settings/users'
import { SystemContainer } from '@pages/settings/systems'
import { OcrTrainingPage } from '@pages/settings/ocr'
import { DashBoardContainer } from '@pages/dashboard'
import { PaymentNotificationsContainer } from '@pages/paymentNotifications'
import { AddressNotConfirmedContainer } from '@pages/addressNotConfirmed'
import { ProfileContainer } from '@pages/profile'

import { Page404 } from '@pages/page404'


/** Маршруты для главной страницы */
const MainRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='dashboard' />} />
            <Route path='dashboard' element={<DashBoardContainer />} />
            <Route path='applications' element={<ApplicationsContainer />} />
            <Route path='applications/:applicationID?' element={<ApplicationsContainer />} />
            <Route path='signature' element={<SignatureContainer />} />
            <Route path='commercialOffers' element={<CommercialOffersContainer />} />

            <Route path='companies' element={<CompaniesContainer />} />
            <Route path='listeners' element={<ListenersContainer />} />
            <Route path='contracts' element={<ContractsContainer />} />

            <Route path='finalExamination' element={<FinalExaminationContainer />} />
            <Route path='archive' element={<ArchiveFinalExaminationContainer />} />
            <Route path='prints' element={<PrintingsFinalExaminationsContainer />} />
            <Route path='finality/:contractID?' element={<FinalityContainer />} />
            <Route path='paymentNotifications' element={<PaymentNotificationsContainer />} />
            <Route path='addressNotConfirmed' element={<AddressNotConfirmedContainer />} />
            <Route path='profile' element={<ProfileContainer />} />
            {/* =============================================== */}
            <Route path='users' element={<UsersContainer />} />
            <Route path='systems' element={<SystemContainer />} />
            <Route path='ocr' element={<OcrTrainingPage />} />
            <Route key='*' path='*' element={<Page404 />} />
        </Routes>
    )
}

export default MainRoutes
